import React from 'react';
import { Typography, Checkbox, FormGroup, FormControlLabel, Box, TextField } from '@mui/material';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import ContainerBox from 'components/ContainerBox';
import { useTranslation } from 'services/localization/useTranslation';

interface Props {
	limit: number | null;
	onLimitChange: (limit: number | null) => void;
}

const DiscountUsageLimit = (props: Props) => {
	const { limit, onLimitChange } = props;
	const { t } = useTranslation();
	const classes = useStyles();

	const handleLimitClick = (e: React.ChangeEvent<HTMLInputElement>) => {
		const checked = e.target.checked;
		if (checked) {
			onLimitChange(0);
		} else {
			onLimitChange(null);
		}
	};

	const handleLimitChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
		const value = e.target.value === '' ? 0 : Number(e.target.value);
		if (isNaN(value)) return;
		onLimitChange(Math.floor(value));
	};

	return (
		<ContainerBox padding="normal">
			<Box mb={3}>
				<Typography variant="h6">{t('discount.usageLimits.title', 'Usage limits')}</Typography>
			</Box>
			<FormGroup>
				<FormControlLabel
					control={
						<Checkbox color="primary" checked={limit !== null} onChange={handleLimitClick} />
					}
					label={t(
						'discount.usageLimits.description',
						'Limit the number of times this discount can be used in total.',
					)}
				/>
			</FormGroup>
			{limit !== null && (
				<Box className={classes.itemSelectWrapper}>
					<TextField
						autoComplete="off"
						name={'usageLimit'}
						value={limit === 0 ? '' : limit}
						placeholder="0"
						onChange={handleLimitChange}
						margin="normal"
						type="number"
					/>
				</Box>
			)}
		</ContainerBox>
	);
};

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		itemSelectWrapper: {
			marginTop: theme.spacing(1),
			marginBottom: theme.spacing(2),
			marginLeft: theme.spacing(4),
			maxWidth: `calc(100% - ${theme.spacing(4)})`,
		},
	}),
);

export default DiscountUsageLimit;
